// export const HerokuURL = 'http://localhost:8080/';
export const HerokuURL = process.env.REACT_APP_BACKEND_URL;

export const LOCAL_DATE_FORMAT = "YYYY-MM-DD";


export const AirlineNames = [
    "AEROFLOT",
    "AERONOMAD",
    "AIR ALGERIA",
    "AIR ARABIA",
    "AIR ARABIA ABU DHABI",
    "AIR ASTANA",
    "AIR AUSTRAL",
    "AIR CANADA",
    "AIR CHINA",
    "AIR FRANCE",
    "AIR INDIA",
    "AIR INDIA EXPRESS",
    "AIR MANAS",
    "AIR MAURITIUS",
    "AIRASIA INDIA",
    "AIRASIA X",
    "ANA",
    "ALLIANCE AIR",
    "AMERICAN AIRLINES",
    "ARIANA AFGHAN AIRLINES",
    "ASIANA AIRLINES",
    "AVIANCA",
    "AZAL AZERBAIJAN AIRLINES",
    "BHUTAN AIRLINES",
    "BIMAN BANGLADESH AIRLINES",
    "BRITISH AIRWAYS",
    "CATHAY PACIFIC",
    "CHINA AIRLINES",
    "CHINA SOUTHERN AIRLINES",
    "DELTA AIR LINES",
    "DRUKAIR",
    "EGYPTAIR",
    "EMIRATES",
    "ETHOPIAN AIRLINES",
    "ETIHAD AIRWAYS",
    "EUROATLANTIC AIRWAYS",
    "FIJI AIRWAYS",
    "FINNAIR",
    "FLEX FLIGHT",
    "FLYBIG",
    "FLY DUBAI",
    "FLYNAS",
    "GARUDA INDONESIA",
    "GO FIRST",
    "GULF AIR",
    "HONG KONG AIRLINES",
    "IBERIA",
    "INDIGO",
    "IRAQI AIRLINES",
    "ITA AIRWAYS",
    "JAL AIRLINES",
    "JAZEERA AIRWAYS",
    "KAM AIR",
    "KENYA AIRWAYS",
    "KLM",
    "KOREAN AIR",
    "KUWAIT AIRWAYS",
    "LOT POLISH AIRLINES",
    "LUFTHANSA",
    "MAHAN AIR",
    "MALAYSIA AIRLINES",
    "MALDIVIAN",
    "MALINDO AIR",
    "MIAT- MONGOLIAN AIRLINES",
    "MYANMAR AIRWAYS",
    "NEPAL AIRLINES",
    "OMAN AIR",
    "QANTAS",
    "QATAR AIRWAYS",
    "SAS",
    "SUADI",
    "SHANDONG AIRLINES",
    "SINGAPORE AIRLINES",
    "SOMAN AIR",
    "SPICE JET",
    "SRILANKAN AIRLINES",
    "SWISS",
    "TAP AIR PORTUGAL",
    "THAI AIRWAYS",
    "THAI LION AIR",
    "TURKISH AIRLINES",
    "UKRAINE AIRLINES",
    "UNITED AIRLINES",
    "UZBEKISTAN AIRWAYS"
];

export const countries = [
    "AUSTRALIA",
    "BOLIVIA",
    "CANADA",
    "FRANCE",
    "GERMANY",
    "INDIA",
    "ITALY",
    "MALAYSIA",
    "NEW ZEALAND",
    "UK",
    "USA",
]

export const asthaans = [
    "BULANDPURI SAHIB",
    "SURREY",
    "EDMONTON",
    "CALGARY",
    "TORONTO",
    "FRANCE",
    "ITALY",
    "MALAYSIA",
    "AUSTRALIA",
    "NEW ZEALAND",
    "FRESNO",
    "INDIANA",
    "NEW YORK",
    "MICHIGAN",
    "WALSALL",
    "GERMANY",
    "BOLIVIA",
]
export const USA_STATES = [
    "ALABAMA",
    "ALASKA",
    "ARKANSAS",
    "ARIZONA",
    "CALIFORNIA",
    "COLORADO",
    "CONNECTICUT",
    "DELAWARE",
    "FLORIDA",
    "GEORGIA",
    "HAWAII",
    "IDAHO",
    "ILLINOIS",
    "INDIANA",
    "IOWA",
    "KANSAS",
    "KENTUCY",
    "LOUISANA",
    "MAINE",
    "MARYLAND",
    "MASSACHUSETTS",
    "MICHIGAN",
    "MINNESOTA",
    "MISSISSPPI",
    "MISSOURI",
    "MONTANA",
    "NEBRASKA",
    "NEVADA",
    "NEW HAMISHIRE",
    "NEW JERSEY",
    "NEW MEXICO",
    "NEW YORK",
    "NORTH CAROLINA",
    "NORTH DAKOTA",
    "OHIO",
    "OKLAHOMA",
    "OREGON",
    "PENNSYLVANIA",
    "RHODE ISLAND",
    "SOUTH CAROLINA",
    "SOUTH DAKOTA",
    "TENNESSEE",
    "TEXAS",
    "UTAH",
    "VERMONT",
    "VIRGINIA",
    "WASHINGTON",
    "WASHINGTON DC",
    "WEST VIRGINIA",
    "WISCONSIN",
    "WYOMING"
]

export const CANADA_PROVINCES = [
    "BRITISH COLUMBIA",
    "ALBERTA",
    "YUKON",
    "MANITOBA",
    "ONTARIO",
    "NORTHWEST TERRITORIES",
    "SASKATCHEWAN",
    "NEW BRUNSWICK",
    "NEWFOUNDLAND",
    "LABRADOR",
    "NOVA SCOTIA",
    "PRINCE EDWARD ISLAND"
]

export const INDIA_AIRPORT_LIST = [
    "AMRITSAR",
    "DELHI"
]

// TODO: use roles instead of this
//controls delete user access
export const OVERIDE_USER_LIST = [
    "eakhosa@gmail.com",
    "satindergill2113@gmail.com",
    "japneetsinghgill@gmail.com",
    "sandeepsingh",
    "1jaspreets@gmail.com",
    "amy"

]

//controls report access
export const SUPERUSER_LIST = [
    "sandeepsingh",
    "eakhosa@gmail.com",
    "1jaspreets@gmail.com",
    "amy"
]

export const ROOMS_REPORT = [
    "sandeepsingh",
    "eakhosa@gmail.com",
    "1jaspreets@gmail.com",
    "amy",
    "japneetsinghgill@gmail.com",
    "jagvir22@hotmail.com",
    "jagmeet_madahar@hotmail.com",
    "jagvir",
    "satindergill2113@gmail.com",
    "diljotbassi13@gmail.com",
    "harpreetbirk_96@hotmail.com",
    "sanghasimran2@gmail.com",
    "jkatwal22@gmail.com"

]

export const SARAVAN = [
    {label: "GOBIND SARVAR NIVAAS", id:"GSN", rooms: [,"101","102","103","104","105","106","107","108","109","110","111","112","113","114","115","116","117","118","119","120","121","122","123","124","125","126","127","128","129","130", "201","202","203","204","205","206","207","208","209","210","211","212","213","214","215","216","217","218","219","220","221","222","223","224","225","226","227","228","229","230"]},
    {label: "KOTHI NIVAAS", id: "KOTHI", rooms: ["DEOL", "GILL", "POONIA", "TAKHAR", "BRAR", "SANGHA", "BAGHRI"]},
    {label: "NAAM NIVAAS", id:"NN", rooms: ["101","102","103","104","105","106","107","108", "110","111","112","113","114","115","116","117","118","119","121","122","123","124","125","126","127","128","129","130","131","132","133", "202","203","204","205","206","207","208","210","211","212","213","214","215","216","217","218","219","221","222","223","224","225","226","227","228","229","230","231","232","233", "301","302","303","304","305","306","307","308","310","311","312","313","314","315","316","317","318","319","321","322","323","324","325","326","327","328","329","330","331","332","333", "Bibi Bhani Hall"]},
    {label: "NIRBHAU NIVAAS", id: "NBN", rooms: ["IK OONKAR - 11", "IK OONKAR - 12", "IK OONKAR - 13", "IK OONKAR - 21", "IK OONKAR - 22", "IK OONKAR - 23", "SATNAM - 11", "SATNAM - 12", "SATNAM - 13", "SATNAM - 21", "SATNAM - 22", "SATNAM - 23", "KARTA PURAKH - 11", "KARTA PURAKH - 12", "KARTA PURAKH - 13", "KARTA PURAKH - 21", "KARTA PURAKH - 22", "KARTA PURAKH - 23", "NIRBHAU - 11", "NIRBHAU - 12", "NIRBHAU - 13", "NIRBHUA - 21", "NIRBHAU - 22", "NIRBHAU - 23", "NIRVAIR - 11", "NIRVAIR - 12", "NIRVAIR - 13", "NIRVAIR - 21", "NIRVAIR - 22", "NIRVAIR - 23", "AKAL MOORAT - 11", "AKAL MOORAT - 12", "AKAL MOORAT - 13", "AKAL MOORAT - 21", "AKAL MOORAT - 22", "AKAL MOORAT - 23", "AJOONI - 11", "AJOONI - 12", "AJOONI - 13", "AJOONI - 21", "AJOONI - 22", "AJOONI - 23","SAIBHANG - 11", "SAIBHANG - 12", "SAIBHANG - 13", "SAIBHANG - 21", "SAIBHANG - 22", "SAIBHANG - 23", "GURPRASAD - 11", "GURPRASAD - 12", "GURPRASAD - 13", "GURPRASAD - 21", "GURPRASAD - 22", "GURPRASAD - 23"]},
    {label: "SEHAJ NIVAAS", id: "SN", rooms: ["101","102","103","104","105","106","107","108","109","110","111","112","113","201","202","203","204","205","206","207","208","209","210","211","212","213","301","302","303","304","305","306","307","308","309","310","311","312","313", "401","402","403","404","405","406","407","408","409","410","411","412","413"]},
   
]